import { GetMissionsFromMapDto } from '../../api/api.g';

export interface ViewportBoundsModel {
  northEast: { lat: number; lng: number };
  southWest: { lat: number; lng: number };
}

export function toApiBoundsStrings(bounds: ViewportBoundsModel, precision = 3) {
  return {
    topLeft: `${bounds.northEast.lat.toFixed(precision)}&${bounds.southWest.lng.toFixed(precision)}`,
    bottomRight: `${bounds.southWest.lat.toFixed(precision)}&${bounds.northEast.lng.toFixed(precision)}`,
  };
}

export function viewportExceedsSpan(bounds: ViewportBoundsModel, maxSpan: number) {
  return Math.abs(bounds.northEast.lat - bounds.southWest.lat) > maxSpan || Math.abs(bounds.northEast.lng - bounds.southWest.lng) > maxSpan;
}

export function getMissionBounds(missions: GetMissionsFromMapDto[]): ViewportBoundsModel | undefined {
  const coordinates = missions
    .map((m) => ({
      lat: Number(m.geocoordinate?.y),
      lng: Number(m.geocoordinate?.x),
    }))
    .filter((coord) => Number.isFinite(coord.lat) && Number.isFinite(coord.lng));

  if (!coordinates.length) {
    return undefined;
  }

  const lats = coordinates.map((coord) => coord.lat);
  const lngs = coordinates.map((coord) => coord.lng);

  return {
    northEast: {
      lat: Math.max(...lats),
      lng: Math.max(...lngs),
    },
    southWest: {
      lat: Math.min(...lats),
      lng: Math.min(...lngs),
    },
  };
}
